export const allowedIconsIds = [
    'arrowRight',
    'arrowLeft',
    'fileDownload',
    'handStars',
    'home',
    'search',
    'medalStarSquare',
    'muted',
    'phoneCalling',
    'shieldStar',
    'shockAbsorber',
    'store',
    'star',
    'temperature',
    'mobileMenu',
    'person',
    'close',
    'mobileSearch',
    'store',
    'time',
    'phoneCalling',
    'copy'
];
export const defaultIcon = allowedIconsIds[0];

export const themes = ['default', 'dark', 'light', 'transparent-border', 'transparent', 'transparent-light'];
export const defaultTheme = themes[0];

export const types = ['default', 'text', 'icon'];
export const defaultType = types[0];

export const sizes = ['default', 'medium', 'small', 'tiny'];
export const defaultSize = sizes[0];
